let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i1qAo")).then(() => parcelRequire('1OvF5'));